module.exports = __webpack_public_path__ + "img/kflc_bg.fada1550.png";